<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>お知らせ管理</h1>
    </div>

    <!-- ボタンエリア -->
    <div class="p-d-flex button-area">
      <button
        pButton
        type="button"
        label="お知らせを登録する"
        class="button-size button1"
        (click)="moveG103()"
      ></button>
      <div class="button-margin"></div>
      <button
        pButton
        type="button"
        label="検索"
        class="button-size button1"
        (click)="getResultDataList()"
      ></button>
    </div>

    <!-- 検索条件入力 -->
    <div class="p-d-flex search-form-area" [formGroup]="g101SearchForm">
      <!-- お知らせ区分 -->
      <div class="p-d-flex">
        <div class="p-as-center item-label">お知らせ区分</div>
        <p-dropdown
          [options]="getDicList(1004)"
          optionLabel="sp_name"
          optionValue="sp_code"
          placeholder="選択してください"
          [showClear]="true"
          styleClass="information-kbn-Form-dropdown"
          formControlName="information_kbn"
        ></p-dropdown>
      </div>

      <!-- 掲載時期 -->
      <div class="p-d-flex date-area">
        <div class="p-as-center item-label">掲載時期</div>
        <p-calendar
          [showIcon]="true"
          [showButtonBar]="true"
          [yearNavigator]="true"
          [monthNavigator]="true"
          placeholder="yy/mm/dd"
          dateFormat="yy/mm/dd"
          dataType="string"
          appendTo="body"
          yearRange="2000:2999"
          formControlName="publishe_start_FROM"
          translate
        ></p-calendar>
        <div class="p-as-center verticalTilde">〜</div>
        <p-calendar
          [showIcon]="true"
          [showButtonBar]="true"
          [yearNavigator]="true"
          [monthNavigator]="true"
          placeholder="yy/mm/dd"
          dateFormat="yy/mm/dd"
          dataType="string"
          appendTo="body"
          yearRange="2000:2999"
          formControlName="publishe_start_TO"
          translate
        ></p-calendar>
      </div>
    </div>

    <!-- 結果表示 -->
    <div class="result-area">
      <!-- 検索結果数 -->
      <div class="result-count-area">
        <label class="count"> {{ resultDataList.length }} </label>
        件
      </div>
      <!-- リスト表示 -->
      <p-table
        #table
        [value]="resultDataList"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
        [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
        emptyMessage="データが存在しません"
        selectionMode="single"
        styleClass="list-area"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="information_kbn">お知らせ区分</th>
            <th class="title">タイトル</th>
            <th class="publishe">掲載状態</th>
            <th class="create_datetime">作成日時</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-resultData>
          <tr class="list" (click)="moveG102(resultData.information_id)">
            <!-- お知らせ区分 -->
            <td>
              {{ resultData.information_kbn.name }}
            </td>
            <!-- タイトル -->
            <td>
              {{ resultData.title }}
            </td>
            <!-- 掲載状態 -->
            <td>
              <p-tag
                value="未掲載"
                styleClass="before-posted-tag"
                *ngIf="
                  0 ==
                  publisheTag(
                    resultData.publishe_start,
                    resultData.publishe_end
                  )
                "
              ></p-tag>
              <p-tag
                value="掲載中"
                styleClass="now-posted-tag"
                *ngIf="
                  1 ==
                  publisheTag(
                    resultData.publishe_start,
                    resultData.publishe_end
                  )
                "
              ></p-tag>
              <p-tag
                value="掲載終了"
                styleClass="end-posted-tag"
                *ngIf="
                  2 ==
                  publisheTag(
                    resultData.publishe_start,
                    resultData.publishe_end
                  )
                "
              ></p-tag>
            </td>
            <!-- 作成日時 -->
            <td>
              {{ resultData.create_datetime }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
